var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "求人確認" }],
            title: "掲載済みの求人・応募フォームタイプ設定",
          },
        }),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "margin-top-1" },
          [
            _c("job-publish-section-title", {
              attrs: { title: "掲載中の求人情報プレビュー" },
            }),
            _vm._v(" "),
            _c("job-published-jobs", {
              attrs: { jobs: _vm.jobs },
              on: { updateEntryType: _vm.updateEntryType },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "margin-top-1" },
          [
            _c("job-publish-section-title", {
              attrs: { title: "掲載中のオプション情報プレビュー" },
            }),
            _vm._v(" "),
            _c("job-published-options", { attrs: { options: _vm.options } }),
          ],
          1
        ),
        _vm._v(" "),
        _c("job-published-past-jobs", {
          staticClass: "margin-top-1",
          attrs: {
            "recent-past-jobs": _vm.recentPastJobs,
            "past-jobs": _vm.pastJobs,
          },
        }),
        _vm._v(" "),
        _c("job-published-past-options", {
          staticClass: "margin-top-1 margin-bottom-3",
          attrs: {
            "recent-past-options": _vm.recentPastOptions,
            "past-options": _vm.pastOptions,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }